import React, { useState } from 'react';
import MyProfile from '../components/MyProfile';
// import Notification from '../components/Notification';
import ChangePassword from '../components/ChangePassword';
// import Support from '../components/Support';
// import Language from '../components/Language';
// import About from '../components/About';
import { useTranslation } from 'react-i18next';

import Modal from 'react-modal';
import ConfirmationModal from '../components/ConfirmationModal';
export default function Profile() {
  const { t } = useTranslation('login');
  const [activeTab, setActiveTab] = useState('profile');

  const [confirmationModal, setConfirmationModal] = useState(false);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const handleLogoutClick = async (e) => {
    e.stopPropagation();
    console.log('Logout clicked');
    setConfirmationModal(true);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return <MyProfile />;
      //   case 'notification':
      //     return <Notification />;
      case 'password':
        return <ChangePassword />;
      //   case 'support':
      //     return <Support />;
      //   case 'language':
      //     return <Language />;
      //   case 'about':
      //     return <About />;
      default:
        return <MyProfile />;
    }
  };

  return (
    <main id="setting">
      <section className="main-section">
        <section className="data">
          <div className="row">
            <div className="col-sm-6">
              <div className="left">
                <h1>{t('SETTINGS')}</h1>
              </div>
            </div>
            <div className="col-sm-6"></div>
          </div>
        </section>

        <div className="left-side">
          <ul>
            <li
              className={activeTab === 'profile' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleTabChange('profile');
              }}
            >
              <span className="image">
                <img src="images/User.svg" alt="" />
                <a href="#">{t('My Profile')}</a>
              </span>
              <img src="images/right-icon.svg" alt="" />
            </li>
            {/* <li className={activeTab === 'notification' ? 'active' : ''}>
              <span className="image">
                <img src="images/Notification.svg" alt="" />
                <a href="#" onClick={(e) => { e.preventDefault(); handleTabChange('notification'); }}>
                  Notification
                </a>
              </span>
              <img src="images/right-icon.svg" alt="" />
            </li> */}
            <li
              className={activeTab === 'password' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleTabChange('password');
              }}
            >
              <span className="image">
                <img src="images/Lock.svg" alt="" />
                <a href="#">{t('CHANGEPASSWORD')}</a>
              </span>
              <img src="images/right-icon.svg" alt="" />
            </li>
            {/* <li
              className={activeTab === 'support' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleTabChange('support');
              }}
            >
              <span className="image">
                <img src="images/Headset.svg" alt="" />
                <a href="#">Support</a>
              </span>
              <img src="images/right-icon.svg" alt="" />
            </li>
            <li
              className={activeTab === 'language' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleTabChange('language');
              }}
            >
              <span className="image">
                <img src="images/language-icon.svg" alt="" />
                <a href="#">Language</a>
              </span>
              <img src="images/right-icon.svg" alt="" />
            </li>
            <li
              className={activeTab === 'about' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleTabChange('about');
              }}
            >
              <span className="image">
                <img src="images/info.svg" alt="" />
                <a href="#">About</a>
              </span>
              <img src="images/right-icon.svg" alt="" />
            </li> */}
            <li onClick={handleLogoutClick}>
              <span className="image">
                <img src="images/Logout.svg" alt="" />
                <a href="#">{t('Log out')}</a>
              </span>
              <img src="images/right-icon.svg" alt="" />
            </li>
          </ul>
        </div>
        <div className="right-side">{renderTabContent()}</div>
      </section>
      <Modal
        isOpen={confirmationModal}
        onRequestClose={() => setConfirmationModal(false)}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        overlayClassName={`modal-overlay add `}
        portalClassName="add cut-off"
      >
        <ConfirmationModal setConfirmationModal={setConfirmationModal} />
      </Modal>
    </main>
  );
}
